export default {"src":"/_next/static/media/play_store_badge.48fcc2c4.svg","height":70,"width":200};